<template>
  <section id="disManager">
    <v-snackbar
      :timeout="5000"
      :value="message.show"
      absolute
      top
      :color="message.type"
    >
      <v-alert :type="message.type" class="mb-0"> {{ message.text }} </v-alert>
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="message.show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-navigation-drawer
      absolute
      temporary
      right
      v-model="drawer"
      class="pa-2"
      style="top: 50px; bottom: 120px; height: auto"
    >
      <v-form class="mx-2">
        <v-row class="ma-0">
          <v-col cols="12" class="pa-0 pt-2">
            <v-autocomplete
              clearable
              :items="regionList"
              outlined
              dense
              hide-details
              label="区域"
              v-model="payload.regionCode"
              item-text="regionName"
              item-value="regionCode"
              @change="setRegion($event)"
              v-if="isAdmin"
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row class="ma-0">
          <v-col cols="12" class="pa-0 pt-2">
            <v-autocomplete
              outlined
              clearable
              hide-details
              dense
              label="省/直辖市 "
              :items="provinceList"
              v-model="payload.provinceCode"
              item-value="code"
              item-text="name"
              @change="setProvince($event)"
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row class="ma-0">
          <v-col cols="12" class="pa-0 pt-2">
            <v-autocomplete
              outlined
              clearable
              hide-details
              dense
              v-model="payload.cityCode"
              label="市"
              :items="cityList"
              item-value="code"
              item-text="name"
              @change="setCity($event)"
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row class="ma-0">
          <v-col cols="12" class="pa-0 pt-2" v-if="!user.role?.includes('Sales') && !user.role?.includes('Sell-in Sales') && !user.role?.includes('External Sales')">
            <v-autocomplete
              :items="salesList"
              outlined
              hide-details
              dense
              label="销售姓名"
              clearable
              item-value="id"
              item-text="displayName"
              v-model="payload.salesId"
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row class="ma-0">
          <v-col cols="12" class="pa-0 pt-2">
            <v-autocomplete
              :items="items"
              outlined
              dense
              clearable
              hide-details
              item-text="name"
              item-value="value"
              label="经销商"
              v-model="payload.dealerType"
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row class="ma-0">
          <v-col cols="12" class="pa-0 pt-2">
            <v-autocomplete
          outlined
          dense
          clearable
          hide-details
          label="合作状态"
          item-value="id"
          item-text="name"
          :items="hzzt"
          v-model="payload.collaborateState"
        ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row class="ma-0">
          <v-col cols="12" class="pa-0 pt-2">
            <v-autocomplete
          outlined
          dense
          clearable
          hide-details
          label="签约情况"
          item-value="id"
          item-text="name"
          :items="qyqk"
          v-model="payload.signatured"
        ></v-autocomplete>
          </v-col>
        </v-row>
      </v-form>
      <template v-slot:append>
        <v-row class="ma-0">
          <v-btn class="primary white--text" @click="clearSearch">清空搜索</v-btn>
          <v-spacer></v-spacer>
          <v-btn class="primary white--text" @click="search">搜索</v-btn>
        </v-row>
      </template>
    </v-navigation-drawer>
    <v-form class="mx-2">
      <v-row class="ma-0">
        <div class="breadcrumb font-weight-black">
          {{ breadcrumb }}
        </div>
        <v-spacer></v-spacer>

        <v-btn color="primary" dark @click.stop="drawer = !drawer">
          筛选
        </v-btn>
        <v-btn class="primary white--text ml-2" @click="redirectToList"
          >查看详情</v-btn
        >
      </v-row>
    </v-form>
    <div id="distributorCharts" class="pa-2 mt-0">
      <v-card id="baseInfo" class="mb-2">
        <v-card-title class="pb-0 font-weight-bold">基础信息</v-card-title>
        <v-card-text style="height: 100%" class="pa-0 px-2">
          <v-list class="transparent">
            <v-list-item class="px-0">
              <v-list-item-title> 一级经销商 </v-list-item-title>

              <v-list-item-subtitle class="text-right font-weight-black">
                {{ basicCount.dealerLevelOneCount || 0 }}
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item class="px-0">
              <v-list-item-title> 二级经销商 </v-list-item-title>

              <v-list-item-subtitle class="text-right font-weight-black">
                {{ basicCount.dealerLevelTwoCount || 0 }}
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item class="px-0">
              <v-list-item-title> 全年所有品牌壁挂炉采购潜力(台) </v-list-item-title>

              <v-list-item-subtitle class="text-right font-weight-black">
                {{ basicCount.ovenSalesCapacityTotal || 0 }}
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item class="px-0">
              <v-list-item-title> 博世壁挂炉钱包份额SoW/% </v-list-item-title>

              <v-list-item-subtitle class="text-right font-weight-black">
                {{ Math.round(Number(basicCount?.boschOvenSow || 0) * 100) }}%
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item class="px-0">
              <v-list-item-title>
                预计当年博世壁挂炉采购贡献(台)
              </v-list-item-title>

              <v-list-item-subtitle class="text-right font-weight-black">
                {{ basicCount.boschOvenSalesCapacityTotal || 0 }}
              </v-list-item-subtitle>
            </v-list-item>
          </v-list>
        </v-card-text>
      </v-card>
      <bar :title="'经销商采购状况 by省份'" :data="provinceBar"></bar>
      <bar :title="'经销商采购状况 by城市'" :data="cityBar"></bar>
      <bar :title="'经销商采购状况 by经销商'" :data="dealerBar"></bar>
      <pie :data="pieData"></pie>
    </div>
    <!-- <v-row class="ma-0 pt-2 action">
      <v-spacer></v-spacer>
      <v-btn
        outlined
        tile
        class="primary white--text ml-2"
        @click="redirectToList"
        >查看详情</v-btn
      >
    </v-row> -->
  </section>
</template>

<script>
import { mapState } from "vuex";
import api from "../../api/api";
import Pie from "./charts/Pie.vue";
import Bar from "./charts/Bar.vue";
export default {
  components: {
    Bar,
    Pie,
  },
  data: () => ({
    breadcrumb: "",
    drawer: false,
    message: {
      show: false,
      type: "success",
      text: "",
    },
    loading: false,
    items: [
      {
        name: "一级",
        value: 1,
      },
      {
        name: "二级",
        value: 2,
      },
    ],
    provinceList: [],
    cityList: [],
    salesList: [],
    hzzt: [],
    payload: {
      dealerId: null,
      regionCode: null,
      provinceCode: null,
      cityCode: null,
      salesId: null,
      addDate: null,
      year: null,
      dealerType: null,
      collaborateState:null,
      signatured:null,
    },
    basicCount: {},
    provinceBar: {},
    cityBar: {},
    dealerBar: {},
    pieData: [],
    regionList: [],
    qyqk:[{"id":1,"name":"已签约"},{"id":0,"name":"未签约"}],
  }),
  computed: {
    ...mapState(["user"]),
    isAdmin() {
      return this.user.role?.includes('HOD') || this.user.role?.includes('RRS') || this.user.role?.includes('SCN');
    },
  },
  created() {
    this.loading = true;
    this.getCategroy();
    this.getRegion();
  },
  methods: {
    getCategroy() {
      api.common.getAllCategory().then((res) => {
        const { data, status } = res.data;
        if (data && status == 200) {
          this.hzzt = data.list.filter((i) => i.categoryType == "hzzt");
        }
      });
    },
    setRegion($event) {
      if ($event) {
        const selectedRegion = this.regionList.filter(
          (i) => i.regionCode == $event
        )[0];
        this.getProvince(selectedRegion.provinces);
        this.getSaleList();
      } else {
        this.provinceList = [];
      }
    },
    setRegionForInit($event) {
      if ($event) {
        const selectedRegion = this.regionList.filter(
          (i) => i.regionCode == $event
        )[0];
        this.getProvince(selectedRegion.provinces);
      } else {
        this.provinceList = [];
      }

      this.payload.regionCode = this.$route.query.region || "";
      this.payload.provinceCode = this.$route.query.province || "";
      this.payload.cityCode = this.$route.query.city || "";
      this.payload.salesId = this.$route.query.salesId || "";
      this.payload.year = this.$route.query.year;
      this.payload.collaborateState = this.$route.query.developmentStatus || "";
      this.payload.signatured = this.$route.query.signatured || "";
      this.payload.dealerType = this.$route.query.dealerType || "";
      if (this.payload.salesId) {
        this.payload.salesId = Number(this.payload.salesId);
      }

      if(this.payload.collaborateState){
        this.payload.collaborateState = Number(this.payload.collaborateState);
      }
      
      if(this.payload.signatured){
        this.payload.signatured = Number(this.payload.signatured);
      }

      if(this.payload.dealerType){
        this.payload.dealerType = Number(this.payload.dealerType);
      }

      if (this.payload.provinceCode) {
        this.cityList = api.pca.getCityByProvince(this.payload.provinceCode);
      } else {
        this.cityList = [];
      }
    },
    getRegion() {
      api.pca.getRegion().then((res) => {
        const { data, status } = res.data;
        if (status == 200 && data) {
          this.regionList = data;
          if (
            Object.prototype.hasOwnProperty.call(this.$route.query, "region") ||
            Object.prototype.hasOwnProperty.call(this.$route.query, "salesId")
          ) {
            this.payload.regionCode = this.$route.query.region || "";
            this.setRegionForInit(this.payload.regionCode);
          } else if (!this.isAdmin) {
            this.setRegion(this.user.userRegionCode);
            this.payload.regionCode = this.user.userRegionCode;
            this.payload.dealerType = this.$route.query.dealerType || "";
            this.payload.collaborateState = this.$route.query.developmentStatus || "";
            if(this.payload.collaborateState){
              this.payload.collaborateState = Number(this.payload.collaborateState);
            }
            this.payload.signatured = this.$route.query.signatured || "";
            if(this.payload.signatured){
              this.payload.signatured = Number(this.payload.signatured);
            }

            if(this.payload.dealerType){
              this.payload.dealerType = Number(this.payload.dealerType);
            }
            if ((this.user.role?.includes('Sales') || this.user.role?.includes('Sell-in Sales') || this.user.role?.includes('External Sales'))) {
              this.payload.salesId = this.user.userId;
            }
            if (this.user.role?.includes('RM') || this.user.role?.includes('HOD')) {
              this.payload.salesId = '';
            }
          }
          this.getSaleList();
          this.search();
        }
      });
    },
    getProvince(byRegion) {
      if (byRegion) {
        this.provinceList = api.pca.getProvince().filter((i) => {
          return (
            byRegion.filter((pro) => pro.provinceCode === i.code).length > 0
          );
        });
      } else {
        this.provinceList = api.pca.getProvince();
      }
    },
    setProvince($event) {
      this.cityList = api.pca.getCityByProvince($event);
      this.payload.cityCode = null;
    },
    setCity() {
      // this.getSaleList();
    },
    getSaleList() {
      api.user
        .getUserWithRoleAndRegion("Sales", this.payload.regionCode, "Sell-in Sales")
        .then((res) => {
          const { data, status } = res.data;
          if (status == 200 && data) {
            this.salesList = data;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    redirectToList() {
      this.$router.push({
        path: "/distributor/list",
        query: {
          region: this.payload.regionCode,
          province: this.payload.provinceCode,
          city: this.payload.cityCode,
          salesId: this.payload.salesId,
          dealerType: this.payload.dealerType,
          developmentStatus:this.payload.collaborateState,
          signatured:this.payload.signatured
        },
      });
    },
    clearSearch(){
      if (this.isAdmin) {
        this.payload.regionCode = null; 
      }

      if ((!this.user.role?.includes('Sales') && !this.user.role?.includes('Sell-in Sales') && this.user.role?.includes('External Sales'))
        || this.user.role?.includes('RM')
        || this.user.role?.includes('HOD')) {
        this.payload.salesId = null;
      }
      this.payload.provinceCode = null;
      this.payload.cityCode = null;
      this.payload.dealerType = null;
      this.payload.collaborateState = null;
      this.payload.signatured = null;
      this.search();
    },
    async search() {
      this.loading = true;
      try {
        const basicRes = api.dealer.getDealerCount(this.payload);
        const provinceRes = api.dealer.getDealerCountBy({
          ...this.payload,
          groupBy: "provinceName",
        });
        const cityRes = api.dealer.getDealerCountBy({
          ...this.payload,
          groupBy: "cityName",
        });
        const dealerRes = api.dealer.getDealerCountBy({
          ...this.payload,
          groupBy: "dealerName",
        });
        const pieRes = api.dealer.getDealerCountPercent(this.payload);
        const promiseAll = await Promise.all([
          basicRes,
          provinceRes,
          cityRes,
          dealerRes,
          pieRes,
        ]);
        const [basic, province, city, dealer, pie] = promiseAll;
        if (basic.data.data && basic.data.status === 200) {
          this.basicCount = basic.data.data[0];
        }
        if (province.data.data && province.data.status === 200) {
          this.provinceBar = {
            boschCount: province.data.data.map(
              (i) => i.boschOvenSalesCapacityTotal
            ),
            otherCount: province.data.data.map((i) => i.ovenSalesCapacityTotal),
            sow: province.data.data.map((i) =>
              Math.round(i.boschOvenSow * 100)
            ),
            xAxis: province.data.data.map((i) => i.provinceName)
          };

          let provinceTotalCount = {};
          let provinceBoschCount = {};
          province.data.data.forEach(i => {
            let key = i.provinceName + '全年所有品牌壁挂炉采购潜力(台)';
            provinceTotalCount[key] = i.ovenSalesCapacityTotal;

            let keyBosch = i.provinceName + '预计当年博世壁挂炉采购贡献(台)';
            provinceBoschCount[keyBosch] = i.boschOvenSalesCapacityTotal;
          });

          this.provinceBar.option = {
            color: [ "#87B957","orange","#c23531",],
            grid: {
              left: "0%",
              right: "0%",
              bottom: "3%",
              top:"30%",
              containLabel: true,
              width: "100%"
            },
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "cross",
                crossStyle: {
                  color: "#999",
                },
              },
              formatter: function (params) {
                let categoryName = params[0].name;
                let dataStr = `<div><p style="margin:0 0px 0px;">${categoryName}</p></div>`;
                let dataStrArray = [];
                params.forEach(item => {
                  let itemData = item.data;
                  if("博世壁挂炉钱包份额SoW/%" == item.seriesName){
                    itemData = itemData + "%";
                  }

                  if('全年所有品牌壁挂炉采购潜力(台)' == item.seriesName){
                    let key = categoryName + '全年所有品牌壁挂炉采购潜力(台)';
                    itemData = provinceTotalCount[key];
                  }

                  if('预计当年博世壁挂炉采购贡献(台)' == item.seriesName){
                    let key = categoryName + '预计当年博世壁挂炉采购贡献(台)';
                    itemData = provinceBoschCount[key];
                  }

                  let dataStrContent = `<div>
                    <div style="margin: 0 0px;">
                      <span style="display:inline-block;margin-right:0px;width:10px;height:10px;background-color:${item.color};"></span>
                      <span>${item.seriesName}</span>
                      <span style="font-weight:bold;float:right;color:#000000;margin-left:0px;">${itemData}</span>
                    </div>
                  </div>`;

                  if("博世壁挂炉钱包份额SoW/%" == item.seriesName){
                    dataStrArray[1] = dataStrContent;
                  }else if('全年所有品牌壁挂炉采购潜力(台)' == item.seriesName){
                    dataStrArray[0] = dataStrContent;
                  }else{
                    dataStrArray[2] = dataStrContent;
                  }
                });

                dataStr = dataStr + dataStrArray[0] + dataStrArray[1] + dataStrArray[2];
                return dataStr;
              },
              position: function (pos, params, el, elRect, size) {
                var obj = { top: 10 };
                obj[['left', 'right'][+(pos[0] < size.viewSize[0] / 2)]] = 30;
                return obj;
              },
              extraCssText: 'width: 80%'
            },
            legend: {
              data: [
                "全年所有品牌壁挂炉采购潜力(台)",
                "博世壁挂炉钱包份额SoW/%",
                "预计当年博世壁挂炉采购贡献(台)",
              ],
            },
            xAxis: [
              {
                type: "category",
                data: this.provinceBar.xAxis,
                axisPointer: {
                  type: "shadow",
                },
                axisLabel: {
                  rotate: 90,
                  width: 60,
                  height: 30,
                  overflow: "truncate",
                },
              },
            ],
            yAxis: [
              {
                type: "value",
                axisLabel: {
                  formatter: function (value) {
                      return "" + value + "";
                  },
                },
              },
              {
                type: "value",
                offset: 0,
                min: 0,
                max: 100,
                interval: 10,
                axisLabel: {
                  formatter: "{value} %",
                },
              },
            ],
            dataZoom: [
              {
                id: "dataZoomX",
                type: "slider",
                xAxisIndex: [0],
                filterMode: "none",
                start: 0,
                end: ((7/this.provinceBar.xAxis.length)*100),
                minSpan:((7/this.provinceBar.xAxis.length)*100),
                maxSpan:((7/this.provinceBar.xAxis.length)*100),
                brushSelect:false
              },
            ],
            series: [
            {
                name: "预计当年博世壁挂炉采购贡献(台)",
                type: "bar",
                stack: "Ad",
                emphasis: {
                  focus: "series",
                },
                data: this.provinceBar.boschCount,
                barWidth: '90%',
                label: {
                  show: true,
                  position: "top",
                },
              },
              {
                name: "博世壁挂炉钱包份额SoW/%",
                type: "line",
                yAxisIndex: 1,
                tooltip: {
                  valueFormatter: function (value) {
                    return value + "%";
                  },
                },
                data: this.provinceBar.sow,
                label: {
                  show: true,
                  position: "bottom",

                  formatter: function ({ value }) {
                    return value + "%";
                  },
                },
              },
              {
                name: "全年所有品牌壁挂炉采购潜力(台)",
                type: "bar",
                stack: "Ad",
                emphasis: {
                  focus: "series",
                },
                data: this.provinceBar.otherCount,
                barWidth: '90%',
                label: {
                  show: true,
                  position: "top",
                },
              },
              
            ],
          };

          let optionBackup = JSON.parse(JSON.stringify(this.provinceBar.option));
          this.provinceBar.optionBackup = optionBackup;
        }
        if (city.data.data && city.data.status === 200) {
          this.cityBar = {
            boschCount: city.data.data.map(
              (i) => i.boschOvenSalesCapacityTotal
            ),
            otherCount: city.data.data.map((i) => i.ovenSalesCapacityTotal),
            sow: city.data.data.map((i) => Math.round(i.boschOvenSow * 100)),
            xAxis: city.data.data.map((i) => i.cityName),
          };
          let cityTotalCount = {};
          let cityBoschCount = {};
          city.data.data.forEach(i => {
            let key = i.cityName + '全年所有品牌壁挂炉采购潜力(台)';
            cityTotalCount[key] = i.ovenSalesCapacityTotal;

            let keyBosch = i.cityName + '预计当年博世壁挂炉采购贡献(台)';
            cityBoschCount[keyBosch] = i.boschOvenSalesCapacityTotal;
          });

          this.cityBar.option = {
            color: ["#87B957", "orange","#c23531",],
            grid: {
              left: "0%",
              right: "0%",
              bottom: "3%",
              top:"30%",
              containLabel: true,
              width: "100%"
            },
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "cross",
                crossStyle: {
                  color: "#999",
                },
              },
              formatter: function (params) {
                let categoryName = params[0].name;
                let dataStr = `<div><p style="margin:0 0px 0px;">${categoryName}</p></div>`;
                let dataStrArray = [];
                params.forEach(item => {
                  let itemData = item.data;
                  if("博世壁挂炉钱包份额SoW/%" == item.seriesName){
                    itemData = itemData + "%";
                  }

                  if('全年所有品牌壁挂炉采购潜力(台)' == item.seriesName){
                    let key = categoryName + '全年所有品牌壁挂炉采购潜力(台)';
                    itemData = cityTotalCount[key];
                  }

                  if('预计当年博世壁挂炉采购贡献(台)' == item.seriesName){
                    let key = categoryName + '预计当年博世壁挂炉采购贡献(台)';
                    itemData = cityBoschCount[key];
                  }
                  let dataStrContent = `<div>
                    <div style="margin: 0 0px;">
                      <span style="display:inline-block;margin-right:0px;width:10px;height:10px;background-color:${item.color};"></span>
                      <span>${item.seriesName}</span>
                      <span style="font-weight:bold;float:right;color:#000000;margin-left:0px;">${itemData}</span>
                    </div>
                  </div>`;

                  if("博世壁挂炉钱包份额SoW/%" == item.seriesName){
                    dataStrArray[1] = dataStrContent;
                  }else if('全年所有品牌壁挂炉采购潜力(台)' == item.seriesName){
                    dataStrArray[0] = dataStrContent;
                  }else{
                    dataStrArray[2] = dataStrContent;
                  }
                });

                dataStr = dataStr + dataStrArray[0] + dataStrArray[1] + dataStrArray[2];
                return dataStr;
              },
              position: function (pos, params, el, elRect, size) {
                var obj = { top: 10 };
                obj[['left', 'right'][+(pos[0] < size.viewSize[0] / 2)]] = 30;
                return obj;
              },
              extraCssText: 'width: 80%'
            },

            legend: {
              data: [
                "全年所有品牌壁挂炉采购潜力(台)",
                "博世壁挂炉钱包份额SoW/%",
                "预计当年博世壁挂炉采购贡献(台)",
              ],
            },
            xAxis: [
              {
                type: "category",
                data: this.cityBar.xAxis,
                axisPointer: {
                  type: "shadow",
                },
                axisLabel: {
                  rotate: 90,
                  width: 60,
                  height: 30,
                  overflow: "truncate",
                },
              },
            ],
            yAxis: [
              {
                type: "value",
                axisLabel: {
                  formatter: function (value) {
                      return "" + value + "";
                  },
                },
              },
              {
                type: "value",
                min: 0,
                max: 100,
                interval: 10,
                axisLabel: {
                  formatter: "{value} %",
                },
              },
            ],
            dataZoom: [
              {
                id: "dataZoomX",
                type: "slider",
                xAxisIndex: [0],
                filterMode: "none",
                start: 0,
                end: ((7/this.cityBar.xAxis.length)*100),
                minSpan:((7/this.cityBar.xAxis.length)*100),
                maxSpan:((7/this.cityBar.xAxis.length)*100),
                brushSelect:false
              },
            ],
            series: [
              {
                name: "预计当年博世壁挂炉采购贡献(台)",
                type: "bar",
                stack: "Ad",
                emphasis: {
                  focus: "series",
                },
                data: this.cityBar.boschCount,
                barWidth: '90%',
                label: {
                  show: true,
                  position: "top",
                },
              },
              {
                name: "博世壁挂炉钱包份额SoW/%",
                type: "line",
                yAxisIndex: 1,
                tooltip: {
                  valueFormatter: function (value) {
                    return value + "%";
                  },
                },
                data: this.cityBar.sow,
                label: {
                  show: true,
                  position: "bottom",

                  formatter: function ({ value }) {
                    return value + "%";
                  },
                },
              },
              {
                name: "全年所有品牌壁挂炉采购潜力(台)",
                type: "bar",
                stack: "Ad",
                emphasis: {
                  focus: "series",
                },
                data: this.cityBar.otherCount,
                barWidth: '90%',
                label: {
                  show: true,
                  position: "top",
                },
              },
            ],
          };

          let optionBackup = JSON.parse(JSON.stringify(this.cityBar.option));
          this.cityBar.optionBackup = optionBackup;
        }
        if (dealer.data.data && dealer.data.status === 200) {
          this.dealerBar = {
            boschCount: dealer.data.data.map(
              (i) => i.boschOvenSalesCapacityTotal
            ),
            otherCount: dealer.data.data.map((i) => i.ovenSalesCapacityTotal),
            sow: dealer.data.data.map((i) => Math.round(i.boschOvenSow * 100)),
            xAxis: dealer.data.data.map((i) => i.dealerName),
          };
          let dealerTotalCount = {};
          let dealerBoschCount = {};
          dealer.data.data.forEach(i => {
            let key = i.dealerName + '全年所有品牌壁挂炉采购潜力(台)';
            dealerTotalCount[key] = i.ovenSalesCapacityTotal;

            let keyBosch = i.dealerName + '预计当年博世壁挂炉采购贡献(台)';
            dealerBoschCount[keyBosch] = i.boschOvenSalesCapacityTotal;
          });
          this.dealerBar.option = {
            color: [ "#87B957","orange","#c23531",],
            grid: {
              left: "0%",
              right: "0%",
              bottom: "3%",
              top:"30%",
              containLabel: true,
              width: "100%"
            },
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "cross",
                crossStyle: {
                  color: "#999",
                },
              },
              formatter: function (params) {
                let categoryName = params[0].name;
                let dataStr = `<div><p style="margin:0 0px 0px;">${categoryName}</p></div>`;
                let dataStrArray = [];
                params.forEach(item => {
                  let itemData = item.data;
                  if("博世壁挂炉钱包份额SoW/%" == item.seriesName){
                    itemData = itemData + "%";
                  }

                  if('全年所有品牌壁挂炉采购潜力(台)' == item.seriesName){
                    let key = categoryName + '全年所有品牌壁挂炉采购潜力(台)';
                    itemData = dealerTotalCount[key];
                  }

                  if('预计当年博世壁挂炉采购贡献(台)' == item.seriesName){
                    let key = categoryName + '预计当年博世壁挂炉采购贡献(台)';
                    itemData = dealerBoschCount[key];
                  }
                  let dataStrContent = `<div>
                    <div style="margin: 0 0px;">
                      <span style="display:inline-block;margin-right:0px;width:10px;height:10px;background-color:${item.color};"></span>
                      <span>${item.seriesName}</span>
                      <span style="font-weight:bold;float:right;color:#000000;margin-left:0px;">${itemData}</span>
                    </div>
                  </div>`;

                  if("博世壁挂炉钱包份额SoW/%" == item.seriesName){
                    dataStrArray[1] = dataStrContent;
                  }else if('全年所有品牌壁挂炉采购潜力(台)' == item.seriesName){
                    dataStrArray[0] = dataStrContent;
                  }else{
                    dataStrArray[2] = dataStrContent;
                  }
                });

                dataStr = dataStr + dataStrArray[0] + dataStrArray[1] + dataStrArray[2];
                return dataStr;
              },
              position: function (pos, params, el, elRect, size) {
                var obj = { top: 10 };
                obj[['left', 'right'][+(pos[0] < size.viewSize[0] / 2)]] = 30;
                return obj;
              },
              extraCssText: 'width: 80%;'
            },

            legend: {
              data: [
                "全年所有品牌壁挂炉采购潜力(台)",
                "博世壁挂炉钱包份额SoW/%",
                "预计当年博世壁挂炉采购贡献(台)",
              ],
            },
            xAxis: [
              {
                type: "category",
                data: this.dealerBar.xAxis,
                axisPointer: {
                  type: "shadow",
                },
                axisLabel: {
                  rotate: 90,
                  width: 60,
                  height: 30,
                  overflow: "truncate",
                },
              },
            ],
            yAxis: [
              {
                type: "value",
                axisLabel: {
                  formatter: function (value) {
                      return "" + value + "";
                  },
                },
              },
              {
                type: "value",
                min: 0,
                max: 100,
                interval: 10,
                axisLabel: {
                  formatter: "{value} %",
                },
              },
            ],
            dataZoom: [
              {
                id: "dataZoomX",
                type: "slider",
                xAxisIndex: [0],
                filterMode: "none",
                start: 0,
                end: ((7/this.dealerBar.xAxis.length)*100),
                minSpan:((7/this.dealerBar.xAxis.length)*100),
                maxSpan:((7/this.dealerBar.xAxis.length)*100),
                brushSelect:false
              },
            ],
            series: [
              {
                name: "预计当年博世壁挂炉采购贡献(台)",
                type: "bar",
                stack: "Ad",
                emphasis: {
                  focus: "series",
                },
                data: this.dealerBar.boschCount,
                barWidth: '90%',
                label: {
                  show: true,
                  position: "top",
                },
              },
              {
                name: "博世壁挂炉钱包份额SoW/%",
                type: "line",
                yAxisIndex: 1,
                tooltip: {
                  valueFormatter: function (value) {
                    return value + "%";
                  },
                },
                data: this.dealerBar.sow,
                label: {
                  show: true,
                  position: "bottom",

                  formatter: function ({ value }) {
                    return value + "%";
                  },
                },
              },
              {
                name: "全年所有品牌壁挂炉采购潜力(台)",
                type: "bar",
                stack: "Ad",
                emphasis: {
                  focus: "series",
                },
                data: this.dealerBar.otherCount,
                barWidth: '90%',
                label: {
                  show: true,
                  position: "top",
                },
              },
            ],
          };

          let optionBackup = JSON.parse(JSON.stringify(this.dealerBar.option));
          this.dealerBar.optionBackup = optionBackup;
        }
        if (pie.data.data && pie.data.status === 200) {
          const data = [
            {
              name: "<20",
              value: pie.data.data?.filter((i) => i.legendName == "lt20").length
                ? Number(
                    pie.data.data?.filter((i) => i.legendName == "lt20")[0]
                      .legendCount
                  )
                : 0,
            },
            {
              name: "20-49",
              value: pie.data.data?.filter((i) => i.legendName == "20to49")
                .length
                ? Number(
                    pie.data.data?.filter((i) => i.legendName == "20to49")[0]
                      .legendCount
                  )
                : 0,
            },
            {
              name: "50-99",
              value: pie.data.data?.filter((i) => i.legendName == "50to99")
                .length
                ? Number(
                    pie.data.data?.filter((i) => i.legendName == "50to99")[0]
                      .legendCount
                  )
                : 0,
            },
            {
              name: ">=100",
              value: pie.data.data?.filter((i) => i.legendName == "ge100")
                .length
                ? Number(
                    pie.data.data?.filter((i) => i.legendName == "ge100")[0]
                      .legendCount
                  )
                : 0,
            },
          ];
          if (data.filter((i) => i.value > 0).length > 0) {
            this.pieData = data;
          } else {
            this.pieData = [];
          }
        }
        this.loading = false;
        this.drawer = false;
      } catch (error) {
        console.log(error);
        this.loading = false;
        this.drawer = false;
        this.message = {
          show: true,
          type: "error",
          text: "数据加载失败，请重试！",
        };
        setTimeout(() => {
          this.message.show = false;
        }, 600000);
      }
    },
  },
};
</script>

<style lang="sass">
#disManager
  height: 100%
  width: 100%
  .action
    position: absolute
    bottom: 20px
    left: 10px
    right: 10px
  #distributorCharts.isSale
    height: calc( 100% - 160px )
  #distributorCharts.isRM
    height: calc( 100% - 200px )
  #distributorCharts
    height: calc( 100% - 50px )
    width: 100%
    overflow: auto
    #baseInfo
      .v-list-item
          min-height: 30px
          .v-list-item__title
            overflow: visible
</style>
